export default "__VITE_ASSET__11f84ec9__"